// import IT from '../../components/ExcerciseTypes/IMAGETEXT/IT1';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import DrawColor from '../../components/ExcerciseTypes/DrawColor';

const json = {
  1: {
    unit: 'Unit 7',
    id: 'WB4-V2-U7-P52-E1',
    audio: '',
    video: '',
    component: UI,
    titleImage: '',
    question: [
    ],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page52/E1/1.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 7',
    id: 'WB4-V2-U7-P52-E2',
    audio: '',
    video: '',
    component: DrawColor,
    exerciseKey: 'img/FriendsPlus/Page52/E2/Key/answerKey.png',
    titleQuestion: [{ num: '2', title: 'Read again. Circle two clothes words. Underline three family words.', color: "#5B5A5D" }],
    question: {
      Write: {
        underlineStyle: {},
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        listStyle: {
          normal: {},
          circle: { padding: 3, border: 'solid 2px', borderRadius: '50%', borderColor: 'gray' },
          underline: { borderBottom: '2px solid gray' },
          // square: { padding: 3, border: 'solid 2px', borderColor: '#4285F4' },
        },
        // limitSelect: 1,
        listWords: [
          "I’m Jason. My dad works in an office.",	//0
          "Every day he gets up at six o’clock. ",	//0
          "He puts on black pants and a tie. He has",	//0
          "breakfast, then he goes to work by car.",	//0

          "In his office, my dad has a big table. ",	//0
          "His computer is on the table. He also has ",	//0
          "a picture of my mom, my sister, ",	//0
          "and me on his table.",	//0

          "He goes home at five o’clock and we all",	//0
          "have dinner together at seven o’clock.",	//0
        ],
        answers: { '2-8': 'circle', '2-14': 'circle', '4-8': 'underline', '6-8': 'underline', '6-12': 'underline' },
        initialValue: {},
      },
      Layout: `
      <div style="line-height: 38px; position: relative;">
          <img src="img/FriendsPlus/Page52/E2/1.jpg" />
          <div style="position: absolute; top: 20px; left:150px;">
            <div><input id='0' type='Circle' /></div>
            <div><input id='1' type='Circle' /></div>
            <div><input id='2' type='Circle' /></div>
            <div><input id='3' type='Circle' /></div>
            <br>
            <div><input id='4' type='Circle' /></div>
            <div><input id='5' type='Circle' /></div>
            <div><input id='6' type='Circle' /></div>
            <div><input id='7' type='Circle' /></div>
            <br>
            <div><input id='8' type='Circle' /></div>
            <div><input id='9' type='Circle' /></div>
          </div>
        
      </div>
      `,
    },
  },
  3: { // Exercise num
    unit: 'Unit 7',
    id: 'WB4-V2-U7-P52-E3',
    audio: '',
    video: '',
    component: DesignUnderLine,
    totalInput: 4,
    exerciseKey: 'img/FriendsPlus/Page52/E3/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page52/E3/0.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page52/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page52/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page52/E3/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page52/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page52/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page52/E3/6.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page52/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page52/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page52/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page52/E3/10.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page52/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page52/E3/12.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page52/E3/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page52/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page52/E3/15.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page52/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page52/E3/17.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page52/E3/18.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page52/E3/19.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page52/E3/20.jpg' },
        { url: 'img/FriendsPlus/Page52/E3/21.jpg', input: 4, },
        { url: 'img/FriendsPlus/Page52/E3/22.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page52/E3/23.jpg' },
        { url: 'img/FriendsPlus/Page52/E3/24.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page52/E3/25.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page52/E3/26.jpg' },
      ],


    ]
  },
}

export default json;